class VideoCountdown {
    constructor(props = {}) {
        this.nextVideoAPIUrl = props.nextVideoAPIUrl;
        this.countInitialTime = props.initialTime;
        this.count = props.initialTime;
        [this.autoplayNode] = document.getElementsByClassName('overlay-autoplay');
        this.autoplayCountdownNode = this.createAutoplayCountdownNode();
        this.videoCountdownCompletedUrl = props.videoCountdownCompletedUrl;
        this._fetchNextVideo();
    }

    createAutoplayCountdownNode() {
        if (!this.count) return null;

        let countdownNode = document.getElementById('autoplay-countdown');
        if (countdownNode === null) {
            countdownNode = document.createElement('span');
            countdownNode.setAttribute('id', 'autoplay-countdown');
            this.autoplayNode.appendChild(document.createTextNode('Next video in '));
            this.autoplayNode.appendChild(countdownNode);
        } else {
            countdownNode.innerText = '';
        }
        return countdownNode;
    }

    _fetchNextVideo() {
        if (this.nextVideoAPIUrl) {
            this.nextVideoLink = null;
            fetch(this.nextVideoAPIUrl)
                .then((response) => response.json())
                .then((data) => {
                    if (data.has_next) {
                        this.nextVideoLink = data.url;
                    }
                });
        }
    }

    _countdownSecond() {
        if (!window.redirectEnabled || !window.autoplayEnabled) {
            this.hide();
            this._resetCount();
            return;
        }

        if (this.count < 2) {
            this._onCountdownDone();
        } else {
            this.count -= 1;
            this.updateAutoplayCountDownDisplay(this.count);
            setTimeout(this._countdownSecond, 1000);
        }
    }

    _onCountdownDone() {
        if (!this.nextVideoLink) {
            this.hide();
            return;
        }
        const nextVideoUrl = new URL(this.nextVideoLink, document.baseURI);
        fetch(this.videoCountdownCompletedUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': Cookies.get('csrftoken'),
            },
            body: JSON.stringify({
                from_url: window.location.href,
                to_url: nextVideoUrl.href,
            }),
        }).then(() => {
            window.location.href = this.nextVideoLink;
            this.hide();
        });
    }

    _resetCount() {
        this.count = this.countInitialTime;
        this.updateAutoplayCountDownDisplay(this.countInitialTime);
    }

    hide() {
        this.autoplayNode.style.display = 'none';
    }

    show() {
        this.autoplayNode.style.display = '';
    }

    updateAutoplayCountDownDisplay(time) {
        if (!this.autoplayCountdownNode) return;
        this.autoplayCountdownNode.innerText = `${time}`;
    }

    run() {
        this.show();
        this._countdownSecond();
    }
}

export default VideoCountdown;
